import { Router, Routes } from '@angular/router';
import { SbLoginComponent } from './components/sb-client/sb-login/sb-login.component';
import { loginGuard } from './guards/sb-login/login.guard';
import { clientGuard } from './guards/sb-client/client.guard';
import { SbRoomDetailsComponent } from './components/sb-client/sb-room-details/sb-room-details.component';
import { SbNotFoundComponent } from './components/sb-client/sb-not-found/sb-not-found.component';
import { inject } from '@angular/core';
import { OrgUserListComponent } from './components/org-admin-client/org-user-list/org-user-list.component';
import { orgAdminClientGuard } from './guards/org-authentication/org-admin-client.guard';
import { OrgUserDetailsComponent } from './components/org-admin-client/org-user-details/org-user-details.component';
import { SbRoomEmptyComponent } from './components/sb-client/sb-room-empty/sb-room-empty.component';
import { KeybackupComponent } from './components/sb-client/keybackup/keybackup.component';
import { keybackupGuard } from './guards/keybackup/keybackup.guard';
import { BaseSettingsDialogComponent } from './common/components/base-settings-dialog/base-settings-dialog.component';
import { SbGeneralSettingsComponent } from './components/sb-client/sb-room-settings/sb-general-settings/sb-general-settings.component';
import { SbMediaSettingsComponent } from './components/sb-client/sb-room-settings/sb-media-settings/sb-media-settings.component';
import { SbSecuritySettingsComponent } from './components/sb-client/sb-room-settings/sb-security-settings/sb-security-settings.component';
import { PrivacySettingsComponent } from './components/sb-client/sb-profil-settings/privacy-settings/privacy-settings.component';
import { ProfilSettingsComponent } from './components/sb-client/sb-profil-settings/profil-settings/profil-settings.component';
import { NotificationSettingsComponent } from './components/sb-client/sb-profil-settings/notification-settings/notification-settings.component';
import { SessionSettingsComponent } from './components/sb-client/sb-profil-settings/session-settings/session-settings.component';
import { KeybackupSettingsComponent } from './components/sb-client/sb-profil-settings/keybackup-settings/keybackup-settings.component';
import { SbProductInformationComponent } from './components/sb-client/sb-version/sb-product-information/sb-product-information.component';
import { SbPrivacyInformationComponent } from './components/sb-client/sb-version/sb-privacy-information/sb-privacy-information.component';
import { OrgBaseComponent } from './components/org-admin-client/org-base/org-base.component';
import { SbClientLeftSidebarComponent } from './components/sb-client/sb-client-left-sidebar/sb-client-left-sidebar.component';
import { OrgReportedEventsComponent } from './components/org-admin-client/org-reported-events/org-reported-events.component';
import { SessionDetailsComponent } from './components/org-admin-client/org-user-details/session-details/session-details.component';
import { DeviceDetailsComponent } from './components/org-admin-client/org-user-details/device-details/device-details.component';
import { OrgAdminServerConfigComponent } from './components/org-admin-client/org-admin-server-config/org-admin-server-config.component';
import { SsoCallbackComponent } from './components/sb-client/sso-callback/sso-callback.component';
import { OrgHealthcareServiceComponent } from './components/org-admin-client/org-healthcare-service/org-healthcare-service.component';
import { OrgOidcUserListComponent } from './components/org-admin-client/org-oidc-user-list.component/org-oidc-user-list.component';
import { OrgGeneralUserListComponent } from './components/org-admin-client/org-general-user-list/org-general-user-list.component';

export const routes: Routes = [
  {
    path: 'login',
    component: SbLoginComponent,
    title: 'SB-Client Login',
    canActivate: [loginGuard]
  },
  {
    path: 'callback',
    component: SsoCallbackComponent
  },
  {
    path: 'keybackup',
    component: KeybackupComponent,
    title: 'Keybackup',
    canActivate: [keybackupGuard]
  },
  {
    path: 'rooms',
    component: SbClientLeftSidebarComponent,
    canActivate: [clientGuard],
    title: 'Rooms',
    children: [
      {
        path: 'version',
        component: BaseSettingsDialogComponent,
        data: {
          tabs: [
            { label: 'Produktinformationen', path: 'product' },
            { label: 'Datenschutzinformationen', path: 'dataprivacy' }
          ],
          dialogTitle: 'Produkt- und Datenschutzinformationen',
          backButtonText: 'Zurück',
          showChevron: true
        },
        children: [
          { path: '', redirectTo: 'profil', pathMatch: 'full' },
          { path: 'product', component: SbProductInformationComponent },
          { path: 'dataprivacy', component: SbPrivacyInformationComponent }
        ]
      },
      {
        path: 'profile-settings',
        component: BaseSettingsDialogComponent,
        data: {
          tabs: [
            { label: 'Profil', path: 'profil' },
            { label: 'Privatsphäre', path: 'privacy' },
            { label: 'Benachrichtigung', path: 'notification' },
            { label: 'Schlüsselverwaltung', path: 'schluesselverwaltung' },
            { label: 'Sitzungen/Geräteverwaltung', path: 'sessions' }
          ],
          dialogTitle: 'Profileinstellungen',
          backButtonText: 'Zurück',
          showChevron: true
        },
        children: [
          { path: '', redirectTo: 'profil', pathMatch: 'full' },
          { path: 'profil', component: ProfilSettingsComponent },
          { path: 'privacy', component: PrivacySettingsComponent },
          { path: 'notification', component: NotificationSettingsComponent },
          {
            path: 'schluesselverwaltung',
            component: KeybackupSettingsComponent
          },
          { path: 'sessions', component: SessionSettingsComponent }
        ]
      },
      {
        path: ':roomId',
        component: SbRoomDetailsComponent,
        children: [
          {
            path: 'settings',
            component: BaseSettingsDialogComponent,
            data: {
              tabs: [
                { label: 'Allgemein', path: 'general' },
                { label: 'Sicherheit', path: 'security' },
                { label: 'Medien', path: 'media' }
              ],
              dialogTitle: 'Allgemeine Chateinstellungen',
              backButtonText: 'Zurück',
              showChevron: true
            },
            children: [
              { path: '', redirectTo: 'general', pathMatch: 'full' },
              { path: 'general', component: SbGeneralSettingsComponent },
              { path: 'security', component: SbSecuritySettingsComponent },
              { path: 'media', component: SbMediaSettingsComponent }
            ]
          },
          {
            path: 'profile-settings',
            component: BaseSettingsDialogComponent,
            data: {
              tabs: [
                { label: 'Profil', path: 'profil' },
                { label: 'Privatsphäre', path: 'privacy' },
                { label: 'Benachrichtigung', path: 'notification' },
                { label: 'Schlüsselverwaltung', path: 'schluesselverwaltung' },
                { label: 'Sitzungen/Geräteverwaltung', path: 'sessions' }
              ],
              dialogTitle: 'Profileinstellungen',
              backButtonText: 'Zurück',
              showChevron: true
            },
            children: [
              { path: '', redirectTo: 'profil', pathMatch: 'full' },
              { path: 'profil', component: ProfilSettingsComponent },
              { path: 'privacy', component: PrivacySettingsComponent },
              {
                path: 'notification',
                component: NotificationSettingsComponent
              },
              {
                path: 'schluesselverwaltung',
                component: KeybackupSettingsComponent
              },
              { path: 'sessions', component: SessionSettingsComponent }
            ]
          },
          {
            path: 'version',
            component: BaseSettingsDialogComponent,
            data: {
              tabs: [
                { label: 'Produktinformationen', path: 'product' },
                { label: 'Datenschutzinformationen', path: 'dataprivacy' }
              ],
              dialogTitle: 'Produkt- und Datenschutzinformationen',
              backButtonText: 'Zurück',
              showChevron: true
            },
            children: [
              { path: '', redirectTo: 'profil', pathMatch: 'full' },
              { path: 'product', component: SbProductInformationComponent },
              { path: 'dataprivacy', component: SbPrivacyInformationComponent }
            ]
          }
        ]
      },
      { path: '', component: SbRoomEmptyComponent }
    ]
  },
  {
    // redirect, welches zum Login weiterleitet, wenn nur der Host oder path aufgerufen wird
    path: '',
    redirectTo: snap =>
      inject(Router).createUrlTree(['login'], {
        queryParams: snap.queryParams
      }),
    pathMatch: 'full'
  },
  {
    path: 'org-admin-client/v2',
    component: OrgBaseComponent,
    canActivate: [orgAdminClientGuard],
    children: [
      { path: ':domain/reports', component: OrgReportedEventsComponent },
      { path: ':domain/healthcare', component: OrgHealthcareServiceComponent },
      {
        path: ':domain/general-users',
        component: OrgGeneralUserListComponent,
        data: {
          tabs: [
            { label: 'Angemeldete Nutzer', path: 'signed-in' },
            { label: 'Angelegte Nutzer', path: 'created' }
          ],
          title: 'Allgemeine Nutzer'
        },
        children: [
          { path: '', redirectTo: 'signed-in', pathMatch: 'full' },
          { path: 'signed-in', component: OrgUserListComponent },
          { path: 'created', component: OrgOidcUserListComponent },
          {
            path: ':signed-in/:userId',
            component: BaseSettingsDialogComponent,
            data: {
              tabs: [
                { label: 'Aktionen', path: 'actions' },
                { label: 'Sitzungen', path: 'sessions' },
                { label: 'Geräteverwaltung', path: 'devices' }
              ],
              dialogTitle: 'Benutzerinformationen',
              backButtonText: 'Zurück',
              showChevron: true
            },
            children: [
              { path: '', redirectTo: 'actions', pathMatch: 'full' },
              { path: 'actions', component: OrgUserDetailsComponent },
              { path: 'sessions', component: SessionDetailsComponent },
              { path: 'devices', component: DeviceDetailsComponent }
            ]
          }
        ]
      },
      {
        path: ':domain/serverconfig',
        component: OrgAdminServerConfigComponent
      }
    ]
  },
  { path: '**', component: SbNotFoundComponent, title: 'Not Found' }
];
